<template>
    <div>
        <v-banner single-line sticky>
            <v-row>
                <v-col>
                    <h3 class="pb-2">
                        OPEN SUB CASE | CASEID :
                        {{ showdata.caseid }} | PROJECT : {{ showdata.project }}
                    </h3>
                </v-col>
            </v-row>
        </v-banner>
        <br />
        <v-card>
            <v-oldinformation
                :condition="condition"
                :information="old_detail"
            />
            <engineer-information
                :condition="condition"
                :information="information"
                v-if="information.site_name !== ''"
            />
            <part-information
                :condition="condition"
                :information="information"
                v-if="information.site_name !== ''"
            />
            <v-row justify="center">
                <v-btn @click="saveCase()" class="ma-4" tile color="success">
                    <v-icon left>mdi-content-save</v-icon>Save
                </v-btn>
                <!-- <v-btn class="ma-4" tile color="warning">
          <v-icon left>mdi-close-octagon</v-icon>Cancel
        </v-btn>-->
            </v-row>
        </v-card>
    </div>
</template>
<script>
import axios from "axios"

import CaseInformation from "../components/CaseInformation"
import ProductInformation from "../components/ProductInformation"
import CustomerInformation from "../components/CustomerInformation"
import EngineerInformation from "../components/EngineerInformation"
import PartInformation from "../components/HpiPartInformation"
import LogInformation from "../components/LogInformation"
import EngineerNewInformation from "../components/EngineerNewInformation"
import OldSub from "../components/OldSub"

import { mapState, mapMutations } from "vuex"

export default {
    components: {
        "case-information": CaseInformation,
        "customer-information": CustomerInformation,
        "product-information": ProductInformation,
        "engineer-information": EngineerNewInformation,
        "part-information": PartInformation,
        "log-information": LogInformation,
        "v-oldinformation": OldSub,
    },
    computed: {
        ...mapState(["isLoading"]),
    },
    mounted() {
        this.getDetail()
    },
    data() {
        return {
            closeOnClick: false,
            showdata: {
                caseid: "",
                project: "",
            },
            condition: {
                status: "subcase",
            },
            information: {
                site_name: "",
                site_address: "",
                site_postcode: "",
                site_district_id: "",
                site_amphur_id: "",
                site_province_id: "",
                branch_id: "",
                engineer: "",
                part: [],
            },
            options: {
                offset: 100,
            },
            lists: [
                {
                    eleId: "#case",
                    eleName: "Case Information",
                },
                {
                    eleId: "#product",
                    eleName: "Products Information",
                },
                {
                    eleId: "#customer",
                    eleName: "Customer Information",
                },
                {
                    eleId: "#lognote",
                    eleName: "Log Note",
                },
                {
                    eleId: "#attach",
                    eleName: "Attachments",
                },
                {
                    eleId: "#parts",
                    eleName: "Parts Information",
                },
                {
                    eleId: "#services",
                    eleName: "Services Information",
                },
                {
                    eleId: "#happycall",
                    eleName: "Happy Call",
                },
                {
                    eleId: "#performance",
                    eleName: "Performance",
                },
            ],
            old_detail: [],
        }
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        async saveCase() {
            this.information.part.map((each) => {
                if (each.part_no == "") {
                    this.information.part = []
                }
            })
            this.information.case_sla_datetime =
                this.information.case_sla_date +
                " " +
                this.information.case_sla_time
            const url = `${process.env.VUE_APP_ROOT_API}/api/hp/new-subcase/${this.$route.params.caseid}`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            try {
                this.mutateIsLoading()
                let { data, status } = await axios.post(
                    url,
                    this.information,
                    options
                )
                this.mutateIsLoading()
                if (status == "200") {
                    this.$swal({
                        title: "บันทึกข้อมูลเรียบร้อย",
                        icon: "success",
                        timer: 2000,
                    }).then((del) => {
                        let url =
                            "/Project/ViewCasepending/Bkk/" +
                            this.$route.params.caseid +
                            "/ViewDetail"
                        this.$router.push(url)
                    })
                }
            } catch (error) {
                console.log(error.message)
            }
        },
        // async getDetail() {
        //   const options = {
        //     headers: {
        //       Authorization: "Bearer " + localStorage.token,
        //     },
        //   };
        //   const url = `${process.env.VUE_APP_ROOT_API}/api/casedetail/${this.$route.params.caseid}`;
        //   try {
        //     const { data } = await axios.get(`${url}`, options);
        //     this.old_detail = data.sub;
        //     this.information = data.main;
        //     this.showdata.caseid = this.information.case_id;
        //     this.showdata.project = this.information.project_name;
        //     this.getDetailSub();
        //   } catch (error) {
        //     console.log(error);
        //   }
        // },
        async getDetail() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/open-new-sub/${this.$route.params.caseid}`
            try {
                const { data } = await axios.get(`${url}`)
                this.old_detail = data.sub
                var part = []
                data.main.parts.map((res) => {
                    part.push({
                        part_issue_id: res.part_issue_id,
                        ponumber: res.ponumber,
                        part_no: res.part_name,
                        part_desc: res.part_description,
                        rma: res.rma,
                        dateorder: "",
                        dateship: "",
                        status: res.status,
                        remark: res.remark,
                        ce_status: res.ce_status,
                    })
                })

                this.information = {
                    part:
                        part.length != 0
                            ? [...part]
                            : [
                                  {
                                      part_issue_id: "",
                                      ponumber: "",
                                      part_no: "",
                                      part_desc: "",
                                      rma: "",
                                      dateorder: "",
                                      dateship: "",
                                      status: "",
                                      remark: "",
                                  },
                              ],
                    ...data.main,
                }
                this.information.engineer = "ZONE"
                this.showdata.caseid = this.information.case_id
                this.showdata.project = this.information.project_name
                this.condition.project = this.information.project_name

                console.log(data, "-data")
            } catch (error) {
                console.log(error)
            }
        },
        getDetailSub() {
            this.information.subs.map((each, i, arr) => {
                if (arr.length - 1 === i) {
                    this.information = {
                        project_id: this.information.project_id,
                        part: [
                            {
                                part_issue_id: "",
                                ponumber: "",
                                part_no: "",
                                part_desc: "",
                                rma: "",
                                dateorder: "",
                                dateship: "",
                                status: "",
                                remark: "",
                            },
                        ],
                        ...each,
                    }
                }
            })
            this.information.engineer = "ZONE"
        },
        gotoLink(eleId) {
            this.$vuetify.goTo(eleId, this.options)
        },
    },
}
</script>
